import { ImagePicker } from './ImagePicker';

/** A dish thumbnail. The picking and shrinking live in ImagePicker. */
export function MenuItemImage({
  itemId,
  imageUrl,
  name,
  canEdit,
}: {
  itemId: string;
  imageUrl: string | null;
  name: string;
  canEdit: boolean;
}) {
  return (
    <div className="card">
      <div className="card-head">
        <h2>Picture</h2>
        <span className="small muted">Shown to guests on the QR menu</span>
      </div>
      <div className="card-body">
        <ImagePicker
          endpoint={`/api/menu/${itemId}/image`}
          imageUrl={imageUrl}
          alt={name}
          canEdit={canEdit}
          invalidateKeys={[['menu'], ['menu', itemId]]}
        />
      </div>
    </div>
  );
}
